<template>
<div>
<div class="mt-5" v-if="transactions.length == 0">
    <br>
    <h2>Lets make new transaction</h2>
    <br>
    <img src="https://cdn.dribbble.com/users/812639/screenshots/6486869/shooping_1-800x600.gif" style="width: 50%;">
</div>
<table v-if="transactions.length > 0" class="table mt-5">
  <thead class="thead-light">
    <tr>
      <th scope="col">ID</th>
      <th scope="col">Date</th>
      <th scope="col">Products</th>
      <th scope="col">Sub Total</th>
      <th scope="col">Status</th>
    </tr>
  </thead>
  <tbody v-if="transactions">
      <tr v-for="(transaction, index) in transactions" :key="index">
        <th scope="row">{{transaction.id}}</th>
        <td>{{transaction.date}}</td>
        <td>
            <ul>
                <li v-for="(product, idx) in transaction.products" :key="idx">
                    {{product.name}}
                </li>
            </ul>
        </td>
        <td>{{transaction.total}}</td>
        <td v-if="!transaction.status">Unpaid</td>
        <td v-if="transaction.status">Paid</td>
      </tr>
  </tbody>
</table>
</div>
</template>

<script>
export default {
    name: 'Transaction',
    methods: {
        fetchTransactions () {
            this.$store.dispatch('fetchTransactions')
        }
    },
    computed: {
        transactions() {
            return this.$store.state.transactions
        }
    },
    created() {
        this.fetchTransactions()
    },
}
</script>